export default __webpack_public_path__ + "static/media/treasure_chest.9def039c.svg";